var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_2244)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_2244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 107
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 0H0V107H107V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 53.5C0 23.9528 23.9528 0 53.5 0C83.0472 0 107 23.9528 107 53.5C107 83.0472 83.0472 107 53.5 107C23.9528 107 0 83.0472 0 53.5Z",
    fill: "#4967D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9521 21.9326C78.9873 27.5191 85.7637 38.2785 85.7637 50.538C85.7637 53.2795 85.4533 55.9177 84.8326 58.4523",
    stroke: "#FFB42A",
    strokeWidth: 1.55183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3627 58.9179C20.6902 56.228 20.3281 53.4347 20.3281 50.538C20.3281 38.2785 27.1045 27.5191 37.1396 21.9326",
    stroke: "#FFB42A",
    strokeWidth: 1.55183,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6776 50.538C81.6776 66.3667 68.8491 79.1434 53.0205 79.1434C37.2435 79.1434 24.415 66.3667 24.415 50.538C24.415 34.761 37.2435 21.9326 53.0205 21.9326C68.8491 21.9326 81.6776 34.761 81.6776 50.538Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3497 50.538C79.3497 65.0734 67.6075 76.8674 53.0203 76.8674C38.4848 76.8674 26.6909 65.0734 26.6909 50.538C26.6909 36.0025 38.4848 24.2086 53.0203 24.2086C67.6075 24.2086 79.3497 36.0025 79.3497 50.538Z",
    fill: "#4967D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6427 63.4698C86.8496 63.8836 86.9013 64.2975 86.9013 64.6596C86.9013 65.0734 86.8496 65.4527 86.7461 65.7976C86.6082 66.1424 86.4357 66.4701 86.2288 66.7805C85.9702 67.0909 85.7116 67.4012 85.2977 67.6081C85.1426 67.1426 85.0908 66.7805 85.0908 66.4184C85.1253 66.0391 85.1943 65.677 85.2977 65.3321C85.4012 64.9873 85.5564 64.6596 85.7633 64.3492C86.0219 64.0388 86.2288 63.7284 86.6427 63.4698Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.022 65.4355C85.953 65.8149 85.8668 66.1942 85.7633 66.5735C85.6254 66.9184 85.5047 67.2805 85.4012 67.6598C85.3495 67.7116 85.2978 67.7633 85.246 67.7633C85.1426 67.7116 85.1426 67.6598 85.1426 67.6081C85.1426 67.5736 85.1426 67.5564 85.1426 67.5564C85.315 67.2115 85.4702 66.8667 85.6081 66.5218C85.7461 66.1425 85.884 65.7804 86.022 65.4355Z",
    fill: "url(#paint0_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1424 70.3497C79.6079 70.5049 79.97 70.7635 80.3321 71.0221C80.6425 71.298 80.9184 71.6084 81.1598 71.9532C81.3667 72.2981 81.5218 72.6947 81.6253 73.143C81.7805 73.5568 81.8322 74.0223 81.7287 74.5913C81.2632 74.3844 80.9011 74.1258 80.5907 73.8154C80.3148 73.5395 80.0735 73.2292 79.8666 72.8843C79.6252 72.505 79.4527 72.1084 79.3493 71.6946C79.1941 71.3325 79.0906 70.8669 79.1424 70.3497Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1255 71.8499C80.7462 72.712 81.3497 73.5914 81.936 74.488C81.9877 74.5397 81.936 74.6949 81.8325 74.7466C81.7808 74.7984 81.6256 74.7984 81.5739 74.6949C81.1256 73.7293 80.6428 72.781 80.1255 71.8499Z",
    fill: "url(#paint1_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8501 74.7465C86.3846 75.1086 85.919 75.3155 85.4534 75.419C85.0051 75.5569 84.5741 75.6086 84.1603 75.5742C83.7119 75.5397 83.2981 75.4535 82.9188 75.3155C82.505 75.1603 82.1429 74.9534 81.7808 74.5913C82.2463 74.2809 82.7119 74.1258 83.1257 74.0223C83.574 73.9189 84.0051 73.8671 84.4189 73.8671C84.8327 73.8671 85.2465 73.9361 85.6603 74.074C86.0742 74.1775 86.488 74.3844 86.8501 74.7465Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9877 74.7465C83.8842 74.8155 82.7979 74.8327 81.7289 74.7982C81.6255 74.7982 81.5737 74.6948 81.5737 74.5913C81.5737 74.4879 81.6772 74.3844 81.7806 74.3844C82.8497 74.5223 83.9187 74.643 84.9877 74.7465Z",
    fill: "url(#paint2_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0214 72.0566C77.5387 72.2635 77.9525 72.5739 78.3146 72.936C78.6249 73.2808 78.9008 73.6602 79.1422 74.074C79.3491 74.4878 79.5043 74.9361 79.6078 75.4189C79.7112 75.9362 79.7112 76.4535 79.6078 77.0742C79.0388 76.8156 78.6766 76.4535 78.3663 76.1431C78.0559 75.7638 77.7973 75.3672 77.5904 74.9534C77.3835 74.5395 77.2283 74.0912 77.1248 73.6084C77.0213 73.1429 76.9179 72.6256 77.0214 72.0566Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0044 73.8154C78.6251 74.85 79.2286 75.9018 79.8149 76.9708C79.8666 77.0743 79.8149 77.1777 79.7114 77.2812C79.6079 77.3329 79.4528 77.2812 79.401 77.1777C78.9527 76.0397 78.4872 74.919 78.0044 73.8154Z",
    fill: "url(#paint3_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3497 77.695C84.7807 78.0571 84.2117 78.264 83.6944 78.3675C83.1771 78.4709 82.6771 78.4882 82.1943 78.4192C81.746 78.3502 81.2977 78.2123 80.8494 78.0054C80.3838 77.7985 79.97 77.5398 79.6079 77.0743C80.1769 76.7639 80.6942 76.6605 81.2115 76.557C81.6942 76.488 82.177 76.4708 82.6598 76.5053C83.1426 76.5398 83.6082 76.6432 84.0565 76.8156C84.522 77.0226 84.9359 77.2295 85.3497 77.695Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2288 77.5398C81.9874 77.5053 80.7631 77.4364 79.5561 77.3329C79.4527 77.2812 79.3492 77.1777 79.401 77.0743C79.401 76.9191 79.5044 76.8674 79.6596 76.8674C80.8321 77.1088 82.0218 77.3329 83.2288 77.5398Z",
    fill: "url(#paint4_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.59 73.712C75.159 74.0223 75.5728 74.4362 75.8832 74.85C76.228 75.2983 76.5039 75.7638 76.7108 76.2466C76.8832 76.7639 76.9867 77.2984 77.0212 77.8502C77.0729 78.4192 77.0729 79.0399 76.8142 79.7124C76.2452 79.3503 75.8831 78.9365 75.5728 78.4709C75.2624 78.0226 75.021 77.5398 74.8486 77.0225C74.6417 76.5398 74.521 76.0225 74.4865 75.4707C74.4348 74.9017 74.4348 74.3327 74.59 73.712Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4692 75.8328C76.021 77.0743 76.5555 78.333 77.0728 79.6089C77.0728 79.7124 77.0211 79.8676 76.9176 79.971C76.7624 80.0228 76.6072 79.971 76.5555 79.8158C76.2451 78.4709 75.8831 77.1433 75.4692 75.8328Z",
    fill: "url(#paint5_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2282 81.1608C82.504 81.5746 81.8833 81.678 81.2625 81.7298C80.6763 81.7642 80.1246 81.7125 79.6073 81.5746C79.0555 81.4366 78.5555 81.2297 78.1072 80.9538C77.6416 80.6435 77.1761 80.2814 76.814 79.7124C77.4864 79.4537 78.1071 79.402 78.6761 79.3503C79.2624 79.3503 79.8314 79.402 80.3832 79.5055C80.9005 79.6089 81.4005 79.7813 81.8833 80.0227C82.4006 80.3331 82.8144 80.6435 83.2282 81.1608Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8487 80.7469C79.4693 80.54 78.0898 80.2814 76.7104 79.971C76.607 79.971 76.5035 79.8158 76.5553 79.6606C76.607 79.5572 76.7622 79.4537 76.9174 79.4537C76.9174 79.4537 76.9174 79.471 76.9174 79.5055C78.2278 79.9538 79.5382 80.3676 80.8487 80.7469Z",
    fill: "url(#paint6_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4692 75.9363C72.9348 76.4018 73.1934 76.9191 73.4521 77.4364C73.659 77.9192 73.7797 78.4364 73.8142 78.9882C73.8831 79.5055 73.8659 80.04 73.7624 80.5918C73.6072 81.1608 73.4521 81.7298 73.0382 82.3505C72.5727 81.8332 72.3658 81.316 72.1589 80.7987C71.9864 80.2814 71.883 79.7641 71.8485 79.2468C71.7795 78.7296 71.7968 78.1951 71.9002 77.6433C72.0037 77.0743 72.1589 76.557 72.4692 75.9363Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.728 78.264C72.9694 79.5745 73.1591 80.9194 73.2971 82.2988C73.2971 82.454 73.1936 82.5574 73.0384 82.6092C72.935 82.6092 72.7798 82.5057 72.7798 82.4023C72.7798 82.4023 72.7798 82.385 72.7798 82.3505C72.8143 80.9711 72.797 79.609 72.728 78.264Z",
    fill: "url(#paint7_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8316 85.4542C78.0557 85.6094 77.4349 85.5577 76.8142 85.4542C76.228 85.3163 75.6934 85.1266 75.2107 84.8852C74.7279 84.6094 74.314 84.2645 73.9692 83.8507C73.6071 83.4369 73.245 82.9713 73.0381 82.3506C73.7623 82.2988 74.383 82.3506 74.952 82.5058C75.5038 82.6437 76.0211 82.8334 76.5038 83.0748C76.9866 83.3162 77.4349 83.6265 77.8488 84.0059C78.2626 84.368 78.6247 84.8335 78.8316 85.4542Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7109 84.3679C75.4004 83.8162 74.1245 83.2127 72.883 82.5575C72.7796 82.5057 72.7278 82.3506 72.8313 82.2471C72.883 82.1437 73.0382 82.0919 73.1934 82.1436C74.3314 82.9368 75.5039 83.6782 76.7109 84.3679Z",
    fill: "url(#paint8_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7456 68.384C81.2112 68.4358 81.5733 68.6427 81.8836 68.8496C82.194 69.0565 82.4526 69.3151 82.6595 69.6255C82.9009 69.9014 83.0734 70.229 83.1768 70.6083C83.2803 71.0222 83.3837 71.436 83.332 71.9533C82.8664 71.8498 82.5044 71.6429 82.194 71.436C81.9181 71.1946 81.6767 70.9187 81.4698 70.6083C81.2284 70.298 81.056 69.9704 80.9525 69.6255C80.7973 69.2634 80.7456 68.8496 80.7456 68.384Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.728 69.6255C82.3143 70.3497 82.9005 71.0739 83.4868 71.798C83.5385 71.9015 83.5385 72.0567 83.435 72.1084C83.3316 72.2119 83.2281 72.1601 83.1764 72.1084C83.1764 72.1084 83.1764 72.0912 83.1764 72.0567C82.6936 71.229 82.2108 70.4186 81.728 69.6255Z",
    fill: "url(#paint9_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8323 71.7464C87.4185 72.1602 87.0047 72.3671 86.6426 72.5223C86.2633 72.6947 85.8839 72.7809 85.5046 72.7809C85.1253 72.7809 84.7459 72.7292 84.3666 72.6257C84.0045 72.4706 83.6941 72.3154 83.332 71.9533C83.7459 71.6429 84.108 71.436 84.5218 71.2808C84.9011 71.1774 85.2804 71.1084 85.6598 71.0739C86.0046 71.0394 86.3667 71.0739 86.7461 71.1774C87.1082 71.2808 87.4703 71.436 87.8323 71.7464Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1769 71.9015C85.2113 72.005 84.263 72.0912 83.3319 72.1602C83.2284 72.1602 83.125 72.1084 83.125 71.9533C83.125 71.8498 83.2284 71.7463 83.3319 71.7463C84.2975 71.8153 85.2458 71.867 86.1769 71.9015Z",
    fill: "url(#paint10_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1939 66.3666C82.6078 66.3666 82.9699 66.5218 83.2285 66.677C83.5389 66.8149 83.7975 67.0219 84.0044 67.2977C84.2113 67.5391 84.3665 67.815 84.4699 68.1254C84.5734 68.4875 84.6768 68.8496 84.6251 69.3669C84.1596 69.3151 83.8492 69.1599 83.5388 69.0048C83.263 68.8323 83.0216 68.6082 82.8146 68.3323C82.6077 68.0909 82.4526 67.815 82.3491 67.5047C82.2457 67.1943 82.1422 66.8322 82.1939 66.3666Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0732 67.4012C83.6595 67.9874 84.2285 68.5909 84.7803 69.2117C84.832 69.2634 84.832 69.4186 84.7285 69.522C84.6768 69.5738 84.5734 69.5738 84.4699 69.522C84.4699 69.522 84.4699 69.5048 84.4699 69.4703C84.0216 68.7806 83.556 68.0909 83.0732 67.4012Z",
    fill: "url(#paint11_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5563 68.953C88.1942 69.3669 87.8839 69.5738 87.5218 69.7807C87.2114 69.9186 86.8838 70.0048 86.5389 70.0393C86.2286 70.0738 85.9182 70.0393 85.6078 69.9359C85.2457 69.8324 84.9354 69.6772 84.625 69.3669C84.9871 69.0048 85.2975 68.7978 85.6078 68.6427C85.9527 68.4702 86.2803 68.3668 86.5907 68.3323C86.901 68.2978 87.2286 68.3151 87.5735 68.384C87.8839 68.4875 88.1942 68.5909 88.5563 68.953Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1078 69.1082C86.2802 69.2806 85.4525 69.4358 84.6249 69.5738C84.5214 69.5738 84.418 69.522 84.418 69.3669C84.418 69.2634 84.5214 69.1599 84.6249 69.1599C85.4525 69.1599 86.2802 69.1427 87.1078 69.1082Z",
    fill: "url(#paint12_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2978 67.7633C84.884 69.4186 84.1598 70.9704 83.3321 72.4705C82.4528 73.9189 81.5217 75.3673 80.3837 76.6605C79.2457 77.9019 78.0559 79.1434 76.711 80.2297C75.4178 81.316 73.9694 82.2471 72.5211 83.1782C72.3141 83.2816 72.0038 83.2299 71.8486 83.023C71.7451 82.7643 71.7969 82.5057 72.0038 82.3505C72.0383 82.3505 72.0555 82.3505 72.0555 82.3505C73.5039 81.5229 74.9523 80.6952 76.2455 79.6607C77.5904 78.6779 78.8318 77.4881 79.9698 76.2467C81.1078 75.0569 82.0907 73.712 82.9701 72.2636C83.8494 70.8152 84.6253 69.3151 85.1426 67.7116C85.1426 67.6599 85.1943 67.6599 85.2461 67.6599C85.2978 67.6599 85.3495 67.7116 85.2978 67.7633Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8622 63.4698C19.6552 63.8836 19.6035 64.2975 19.6035 64.6596C19.6035 65.0734 19.6725 65.4527 19.8104 65.7976C19.9139 66.1424 20.0863 66.4701 20.3277 66.7805C20.5863 67.0909 20.845 67.4012 21.2588 67.6081C21.414 67.1426 21.414 66.7805 21.414 66.4184C21.414 66.0391 21.345 65.677 21.2071 65.3321C21.1036 64.9873 20.9484 64.6596 20.7415 64.3492C20.5346 64.0388 20.276 63.7284 19.8622 63.4698Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4829 65.4355C20.5864 65.8149 20.6898 66.1942 20.7933 66.5735C20.8967 66.9184 21.0174 67.2805 21.1554 67.6598C21.1554 67.7116 21.2588 67.7633 21.3106 67.7633C21.3623 67.7116 21.414 67.6598 21.3623 67.6081C21.3623 67.5736 21.3623 67.5564 21.3623 67.5564C21.2243 67.2115 21.0864 66.8667 20.9485 66.5218C20.776 66.1425 20.6209 65.7804 20.4829 65.4355Z",
    fill: "url(#paint13_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4148 70.3497C26.8975 70.5049 26.5354 70.7635 26.225 71.0221C25.8802 71.298 25.6043 71.6084 25.3974 71.9532C25.1905 72.2981 25.018 72.6947 24.8801 73.143C24.7766 73.5568 24.7249 74.0223 24.7766 74.5913C25.2422 74.3844 25.6043 74.1258 25.9147 73.8154C26.225 73.5395 26.4837 73.2292 26.6906 72.8843C26.8975 72.505 27.0699 72.1084 27.2078 71.6946C27.3113 71.3325 27.4148 70.8669 27.4148 70.3497Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3801 71.8499C25.7594 72.712 25.1731 73.5914 24.6214 74.488C24.5697 74.5397 24.5697 74.6949 24.6731 74.7466C24.7766 74.7984 24.88 74.7984 24.9317 74.6949C25.4145 73.7293 25.8973 72.781 26.3801 71.8499Z",
    fill: "url(#paint14_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6553 74.7465C20.1726 75.1086 20.6381 75.3155 21.0519 75.419C21.5002 75.5569 21.9485 75.6086 22.3968 75.5742C22.8107 75.5397 23.2245 75.4535 23.6383 75.3155C24.0004 75.1603 24.4142 74.9534 24.7763 74.5913C24.259 74.2809 23.8452 74.1258 23.3797 74.0223C22.9659 73.9189 22.5348 73.8671 22.0865 73.8671C21.6727 73.8671 21.2588 73.9361 20.845 74.074C20.4312 74.1775 20.0691 74.3844 19.6553 74.7465Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5176 74.7465C22.6211 74.8155 23.7074 74.8327 24.7764 74.7982C24.8799 74.7982 24.9833 74.6948 24.9833 74.5913C24.9316 74.4879 24.8281 74.3844 24.7247 74.3844C23.6556 74.5223 22.5866 74.643 21.5176 74.7465Z",
    fill: "url(#paint15_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5354 72.0566C28.9664 72.2635 28.6043 72.5739 28.2422 72.936C27.8974 73.2808 27.6215 73.6602 27.4146 74.074C27.1732 74.4878 27.018 74.9361 26.949 75.4189C26.8456 75.9362 26.7938 76.4535 26.949 77.0742C27.4663 76.8156 27.8284 76.4535 28.1387 76.1431C28.4836 75.7638 28.7595 75.3672 28.9664 74.9534C29.1733 74.5395 29.3285 74.0912 29.4319 73.6084C29.5354 73.1429 29.5871 72.6256 29.5354 72.0566Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5524 73.8154C27.8972 74.85 27.2937 75.9018 26.742 76.9708C26.6902 77.0743 26.742 77.1777 26.8454 77.2812C26.9489 77.3329 27.1041 77.2812 27.1558 77.1777C27.5696 76.0397 28.0352 74.919 28.5524 73.8154Z",
    fill: "url(#paint16_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.207 77.695C21.776 78.0571 22.2933 78.264 22.8106 78.3675C23.3279 78.4709 23.8279 78.4882 24.3107 78.4192C24.7935 78.3502 25.259 78.2123 25.7073 78.0054C26.1212 77.7985 26.535 77.5398 26.8971 77.0743C26.3281 76.7639 25.8625 76.6605 25.3452 76.557C24.828 76.488 24.3279 76.4708 23.8451 76.5053C23.3624 76.5398 22.8968 76.6432 22.4485 76.8156C22.0347 77.0226 21.5691 77.2295 21.207 77.695Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2764 77.5398C24.5178 77.5053 25.7593 77.4364 27.0008 77.3329C27.1042 77.2812 27.1559 77.1777 27.1559 77.0743C27.1042 76.9191 27.0008 76.8674 26.8973 76.8674C26.8973 76.8674 26.8801 76.8674 26.8456 76.8674C25.6731 77.1088 24.4833 77.3329 23.2764 77.5398Z",
    fill: "url(#paint17_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9668 73.712C31.346 74.0223 30.984 74.4362 30.6219 74.85C30.277 75.2983 30.0184 75.7638 29.8459 76.2466C29.639 76.7639 29.5183 77.2984 29.4838 77.8502C29.4321 78.4192 29.4838 79.0399 29.7425 79.7124C30.3115 79.3503 30.6736 78.9365 30.9839 78.4709C31.2943 78.0226 31.5357 77.5398 31.7081 77.0225C31.8806 76.5398 32.0013 76.0225 32.0702 75.4707C32.122 74.9017 32.122 74.3327 31.9668 73.712Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0873 75.8328C30.5011 77.0743 29.9665 78.333 29.4838 79.6089C29.432 79.7124 29.4837 79.8676 29.6389 79.971C29.7424 80.0228 29.8976 79.971 29.9493 79.8158C30.2942 78.4709 30.6735 77.1433 31.0873 75.8328Z",
    fill: "url(#paint18_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3281 81.1608C24.0006 81.5746 24.673 81.678 25.242 81.7298C25.8628 81.7642 26.4318 81.7125 26.9491 81.5746C27.4663 81.4366 27.9664 81.2297 28.4492 80.9538C28.9147 80.6435 29.3285 80.2814 29.6906 79.7124C29.0182 79.4537 28.4492 79.402 27.8284 79.3503C27.2422 79.3503 26.6904 79.402 26.1731 79.5055C25.6214 79.6089 25.1041 79.7813 24.6213 80.0227C24.1558 80.3331 23.6902 80.6435 23.3281 81.1608Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6558 80.7469C27.0697 80.54 28.4491 80.2814 29.794 79.971C29.9492 79.971 30.0009 79.8158 29.9492 79.6606C29.8974 79.5572 29.7422 79.4537 29.6388 79.4537C29.6388 79.4537 29.6216 79.471 29.5871 79.5055C28.3111 79.9538 27.0007 80.3676 25.6558 80.7469Z",
    fill: "url(#paint19_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0873 75.9363C33.57 76.4018 33.3114 76.9191 33.1045 77.4364C32.8976 77.9192 32.7596 78.4364 32.6907 78.9882C32.6562 79.5055 32.6907 80.04 32.7941 80.5918C32.8976 81.1608 33.1045 81.7298 33.5183 82.3505C33.9321 81.8332 34.1908 81.316 34.3977 80.7987C34.5701 80.2814 34.6736 79.7641 34.708 79.2468C34.7425 78.7296 34.7253 78.1951 34.6563 77.6433C34.5529 77.0743 34.3977 76.557 34.0873 75.9363Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7768 78.264C33.5699 79.5745 33.3975 80.9194 33.2595 82.2988C33.2078 82.454 33.3113 82.5574 33.4665 82.6092C33.6217 82.6092 33.7251 82.5057 33.7768 82.4023C33.7768 82.4023 33.7768 82.385 33.7768 82.3505C33.7079 80.9711 33.7079 79.609 33.7768 78.264Z",
    fill: "url(#paint20_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6729 85.4542C28.5005 85.6094 29.1212 85.5577 29.6902 85.4542C30.2765 85.3163 30.811 85.1266 31.2938 84.8852C31.7766 84.6094 32.2076 84.2645 32.587 83.8507C32.9491 83.4369 33.2595 82.9713 33.4664 82.3506C32.7422 82.2988 32.1732 82.3506 31.6042 82.5058C31.0179 82.6437 30.4834 82.8334 30.0006 83.0748C29.5178 83.3162 29.0695 83.6265 28.6557 84.0059C28.2936 84.368 27.9315 84.8335 27.6729 85.4542Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8452 84.3679C31.1557 83.8162 32.4144 83.2127 33.6213 82.5575C33.7765 82.5057 33.7765 82.3506 33.7248 82.2471C33.6213 82.1437 33.4661 82.0919 33.3627 82.1436C33.3282 82.1436 33.311 82.1436 33.311 82.1436C32.173 82.9368 31.0177 83.6782 29.8452 84.3679Z",
    fill: "url(#paint21_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.759 68.384C25.2935 68.4358 24.9831 68.6427 24.621 68.8496C24.3107 69.0565 24.052 69.3151 23.8451 69.6255C23.6382 69.9014 23.4658 70.229 23.3279 70.6083C23.2244 71.0222 23.1727 71.436 23.2244 71.9533C23.6899 71.8498 24.0003 71.6429 24.3107 71.436C24.621 71.1946 24.8797 70.9187 25.0866 70.6083C25.2935 70.298 25.4659 69.9704 25.6039 69.6255C25.7073 69.2634 25.8108 68.8496 25.759 68.384Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8278 69.6255C24.2071 70.3497 23.6208 71.0739 23.0691 71.798C23.0173 71.9015 23.0173 72.0567 23.0691 72.1084C23.1725 72.2119 23.276 72.1601 23.3794 72.1084C23.3794 72.1084 23.3794 72.0912 23.3794 72.0567C23.8277 71.229 24.3105 70.4186 24.8278 69.6255Z",
    fill: "url(#paint22_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6724 71.7464C19.0862 72.1602 19.5 72.3671 19.9138 72.5223C20.2932 72.6947 20.6725 72.7809 21.0518 72.7809C21.4312 72.7809 21.7933 72.7292 22.1381 72.6257C22.5002 72.4706 22.8623 72.3154 23.1727 71.9533C22.8106 71.6429 22.3968 71.436 22.0347 71.2808C21.6553 71.1774 21.276 71.1084 20.8966 71.0739C20.5173 71.0394 20.138 71.0739 19.7586 71.1774C19.3966 71.2808 19.0345 71.436 18.6724 71.7464Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3276 71.9015C21.2932 72.005 22.2588 72.0912 23.2244 72.1602C23.3278 72.1602 23.3796 72.1084 23.3796 71.9533C23.3796 71.8498 23.3278 71.7463 23.2244 71.7463C23.1899 71.7463 23.1727 71.7463 23.1727 71.7463C22.2416 71.8153 21.2932 71.867 20.3276 71.9015Z",
    fill: "url(#paint23_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3626 66.3666C23.8971 66.3666 23.5867 66.5218 23.2763 66.677C23.0005 66.8149 22.7591 67.0219 22.5522 67.2977C22.3453 67.5391 22.1728 67.815 22.0349 68.1254C21.9314 68.4875 21.8797 68.8496 21.9314 69.3669C22.3452 69.3151 22.6556 69.1599 22.966 69.0048C23.2419 68.8323 23.4833 68.6082 23.6902 68.3323C23.8971 68.0909 24.0523 67.815 24.1557 67.5047C24.3109 67.1943 24.3626 66.8322 24.3626 66.3666Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4313 67.4012C22.8796 67.9874 22.3278 68.5909 21.776 69.2117C21.6726 69.2634 21.7243 69.4186 21.776 69.522C21.8795 69.5738 21.9829 69.5738 22.0347 69.522C22.0347 69.522 22.0519 69.5048 22.0864 69.4703C22.5347 68.7806 22.983 68.0909 23.4313 67.4012Z",
    fill: "url(#paint24_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 68.953C18.3104 69.3669 18.6725 69.5738 18.9828 69.7807C19.3277 69.9186 19.6553 70.0048 19.9657 70.0393C20.3105 70.0738 20.6381 70.0393 20.9485 69.9359C21.2589 69.8324 21.5692 69.6772 21.8796 69.3669C21.5692 69.0048 21.2588 68.7978 20.8968 68.6427C20.5864 68.4702 20.276 68.3668 19.9657 68.3323C19.6208 68.2978 19.2932 68.3151 18.9828 68.384C18.6207 68.4875 18.3104 68.5909 18 68.953Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3965 69.1082C20.2241 69.2806 21.0518 69.4358 21.8794 69.5738C21.9829 69.5738 22.0863 69.522 22.0863 69.3669C22.0863 69.2634 22.0346 69.1599 21.9311 69.1599C21.8967 69.1599 21.8794 69.1599 21.8794 69.1599C21.0518 69.1599 20.2241 69.1427 19.3965 69.1082Z",
    fill: "url(#paint25_radial_39_2244)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4139 67.7116C21.8795 69.3151 22.6554 70.8152 23.5348 72.2636C24.4141 73.712 25.4487 75.0569 26.5867 76.2467C27.7247 77.4881 28.9145 78.6779 30.2594 79.6607C31.6043 80.6952 33.001 81.5229 34.4493 82.3505H34.5011C34.708 82.454 34.8114 82.7643 34.6562 82.9713C34.5528 83.2299 34.2424 83.2816 34.0355 83.1782C32.5354 82.2471 31.087 81.316 29.7938 80.2297C28.4489 79.1434 27.2592 77.9019 26.1212 76.6605C25.0349 75.3673 24.0521 73.9189 23.2244 72.4705C22.3968 70.9704 21.6726 69.4186 21.207 67.7633C21.207 67.7116 21.207 67.6599 21.2588 67.6599C21.3105 67.6599 21.3622 67.6599 21.4139 67.7116Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7791 83.4368V85.1438C60.7791 88.5061 58.6065 91.4028 55.5546 92.4374C54.8821 93.265 54.2096 93.7306 53.7958 93.9892L53.5889 97.9723L55.3994 101.128C55.8132 101.128 56.1236 101.438 56.1236 101.852V102.679H50.0714V101.852C50.0714 101.438 50.3818 101.128 50.7956 101.128L52.6061 97.9723L52.4509 93.9892C51.9853 93.7306 51.4163 93.265 50.7439 92.4891C47.5885 91.558 45.2607 88.6096 45.2607 85.1438V83.4368H47.7437V81.9884H58.503V83.4368H60.7791ZM50.1231 91.7649C49.399 90.6787 48.623 89.1268 48.054 86.9543C47.8471 86.1266 47.7437 85.2817 47.7437 84.4196V84.0058H45.778V85.1438C45.778 88.0923 47.5885 90.6787 50.1231 91.7649ZM60.2101 84.0058H58.4513V84.4196C58.4513 85.2817 58.3478 86.1266 58.1409 86.9543C57.5719 89.0234 56.8477 90.5235 56.1236 91.6098C58.5548 90.4718 60.2101 87.9888 60.2101 85.1438V84.0058Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6926 95.4377L53.7961 93.9893H52.4512L52.5029 95.4377H53.6926Z",
    fill: "#CF9222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7437 83.6954H58.503",
    stroke: "#CF9222",
    strokeWidth: 0.620732,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7437 84.4713H58.503",
    stroke: "#CF9222",
    strokeWidth: 0.413822,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5374 102.679H49.5024V102.266C49.5024 102.059 49.6576 101.904 49.8645 101.904H56.1236C56.3305 101.904 56.5374 102.059 56.5374 102.266V102.679Z",
    fill: "#CF9222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.02 85.4542L53.589 87.2646H55.5546L54.0028 88.4544L54.5718 90.2648L53.02 89.1268L51.4164 90.2648L52.0372 88.4544L50.4854 87.2646H52.3993L53.02 85.4542Z",
    fill: "#CF9222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8008 18L48.5371 8.04688H49.7744L48.0381 18H46.8008ZM49.3643 18L51.1074 8.04688H52.3447L50.6016 18H49.3643ZM53.3633 12.0459H46.2471V10.8906H53.3633V12.0459ZM52.8438 15.1973H45.7344V14.0488H52.8438V15.1973ZM59.1123 8.02637V18H57.1436V10.2959L54.7783 11.0479V9.49609L58.9004 8.02637H59.1123Z",
    fill: "#FFB42A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2017 44.4435V40.3387C45.2017 38.1129 46.0691 36.0161 47.6351 34.4435C49.2012 32.871 51.2812 32 53.4978 32C55.7143 32 57.8024 32.871 59.3684 34.4435C60.9345 36.0161 61.7938 38.1129 61.7938 40.3387V44.4435C61.7938 46.6694 60.9345 48.7581 59.3684 50.3306C57.8024 51.9032 55.7143 52.7742 53.4978 52.7742C51.2812 52.7742 49.2012 51.9032 47.6351 50.3306C46.0691 48.7581 45.2017 46.6694 45.2017 44.4435ZM69.4715 67.7742C68.9735 68.629 68.1704 69.2419 67.2228 69.5081C62.7816 70.7419 57.3125 71 53.4978 71C49.6911 71 44.2139 70.7419 39.7808 69.5081C38.8331 69.2419 38.03 68.629 37.5321 67.7742C37.0261 66.9274 36.8735 65.9274 37.1064 64.9597L38.3994 59.4758C38.7126 58.1694 39.5639 57.0726 40.7445 56.4597L48.0608 52.6452C49.6589 53.7177 51.5382 54.2903 53.4978 54.2903C55.4654 54.2903 57.3446 53.7177 58.9348 52.6452L66.251 56.4597C67.4396 57.0726 68.2909 58.1694 68.5961 59.4758L69.8971 64.9597C70.122 65.9274 69.9774 66.9274 69.4715 67.7742Z",
    fill: "#FFB42A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7852 49.6825) rotate(70.4512) scale(31.0841 31.0845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7861 49.6825) rotate(70.4517) scale(31.0841 31.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2813 74.5986) rotate(70.4529) scale(1.22137 1.22133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.9144 48.9866) rotate(75.0011) scale(31.0844 31.0844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.3196 77.2212) rotate(74.9885) scale(1.386 1.38601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.4433 48.5806) rotate(81.8365) scale(31.0842 31.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.7377 80.1169) rotate(81.8433) scale(1.57503 1.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.84 50.1159) rotate(97.0595) scale(31.084 31.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7892 83.2361) rotate(97.0573) scale(1.57463 1.57462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.785 49.6824) rotate(70.4515) scale(31.0844 31.0847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.6623 71.961) rotate(70.4599) scale(1.09343 1.09339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.7852 49.6823) rotate(70.4516) scale(31.0849 31.0849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.7743 69.3446) rotate(70.4368) scale(0.963975 0.963988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.744 49.6825) rotate(109.548) scale(31.0841 31.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7444 49.6825) rotate(109.548) scale(31.0841 31.084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2489 74.5986) rotate(109.547) scale(1.22136 1.22134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6156 48.9866) rotate(104.999) scale(31.0844 31.0844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2105 77.2212) rotate(105.011) scale(1.386 1.38601)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0859 48.5806) rotate(98.1636) scale(31.0842 31.0843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7916 80.1169) rotate(98.1567) scale(1.57503 1.575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6896 50.1154) rotate(82.9407) scale(31.0839 31.0839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.74 83.2361) rotate(82.9427) scale(1.57463 1.57462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7439 49.6824) rotate(109.548) scale(31.0843 31.0845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8671 71.961) rotate(109.54) scale(1.09343 1.0934)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7445 49.6824) rotate(109.549) scale(31.0854 31.0851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_39_2244",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7549 69.3446) rotate(109.563) scale(0.963975 0.963986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E155A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_2244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.d8caaf0c6e4120fd19b6880727f0f7c4.svg";
export { ForwardRef as ReactComponent };